import React from "react";
import { ImCross } from "react-icons/im";
import { MyGlobalContext } from "../../Context";
import LousCityBar from "../../images/cocktail.png";

const PurchaseFullDetails = ({ checkId }) => {
  const { purchaseData, setCheckDetails } = MyGlobalContext();

  // this filter function for getting the specific item from purchaseHistory
  const filterSpecificItem =
    purchaseData !== null &&
    purchaseData?.purchaseHistory.filter((item) => {
      return item._id === checkId;
    });
//   console.log(filterSpecificItem);
  // const {purchaseHistory} = purchaseData !== null && purchaseData;
  return (
    <section className="absolute w-full h-full left-0 top-0 bg-[rgba(0,0,0,0.8)] text-white checkFullDetailsPurchase">
      <section className="px-6 pt-12 md:px-10 flex justify-center my-auto">
        <div className="bg-[rgba(255,204,0,0.5)] rounded-lg details-shadow text-center p-2 relative">
          <button
            onClick={() => {
              setCheckDetails(false);
            }}
            className=" absolute  left-1 top-1 bg-[rgba(4,4,4,0.5)] p-2 rounded-lg text-[white!important]"
          >
            <ImCross />
          </button>
          <img className=" w-[170px] h-[75px] mx-auto pt-5" src={LousCityBar} alt="" />
          <h1 className="text-center uppercase">Order Details</h1>
          <div className=" w-[100px] h-1 bg-white mx-auto rounded-md mb-2"></div>
          {filterSpecificItem?.map((items) => {
            const { _id, products, totalPrice, totalItem, bankCardDetails, createdAt } =
              items;
              const time = new Date(createdAt).toLocaleTimeString();
            return (
              <article key={_id}>
                <h1 className="order-id">
                  Order Id: <span>{_id}</span>
                </h1>
                <p>Total Items: {totalItem}</p>
                <p>Total Price: {totalPrice}$</p>
                <div className="pb-2">
                  <h1 className="text-[black] mt-3 border-y-4 border-black rounded-3xl">Products Details</h1>
                  {products.map((product) => {
                    const { id, name, quantity } = product;
                    return (
                      <div key={id} className=" bg-[rgb(0,0,0)] py-2 mt-2">
                        <p>
                          Name: {name} & Quantity: {quantity}
                        </p>
                      </div>
                    );
                  })}
                </div>
                <h1 className=" text-[#00fff7] purchase-time">Purchase Time: {time}</h1>
              </article>
            );
          })}
        </div>
      </section>
    </section>
  );
};

export default PurchaseFullDetails;
